import React from 'react';

import { useTranslation } from 'react-i18next';

export function InspectionsDashboard() {
  const { t } = useTranslation();

  return (
    <div style={{ padding: '2rem' }}>
      <h1>{t('web.admin.inspections.dashboard.title')}</h1>
      <p>{t('web.admin.inspections.dashboard.placeholder')}</p>
    </div>
  );
}
